import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("mc_token");
    if (!token) { setUser(null); setLoading(false); return; }
    api.get("/auth/me").then(r => setUser(r.data)).catch(() => setUser(null)).finally(() => setLoading(false));
  }, []);

  const login = useCallback(async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    localStorage.setItem("mc_token", r.data.token);
    setUser(r.data.user);
    return r.data.user;
  }, []);
  const logout = useCallback(() => {
    localStorage.removeItem("mc_token");
    setUser(null);
    window.location.href = "/login";
  }, []);

  const value = useMemo(() => ({ user, loading, login, logout, setUser }), [user, loading, login, logout]);
  return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);

export const can = (user, action) => {
  if (!user) return false;
  if (user.role === "admin") return true;
  if (user.role === "employee") return ["create_vehicle", "edit_vehicle", "create_repair", "create_sale", "create_customer"].includes(action);
  if (user.role === "accountant") return ["view_finance", "create_expense", "view_reports"].includes(action);
  return false;
};
